import { createRoot } from 'react-dom/client';
import App from './App';
import { history } from './components/Utilities/Router/History';
import Router from './components/Utilities/Router/Router';

import 'regenerator-runtime/runtime';

createRoot(document.getElementById('root')).render(
  <Router history={history}>
    <App />
  </Router>
);
